import { environment } from 'src/environment';
import { Component, Input, OnInit, Output, ViewChild, EventEmitter} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import * as uikit from 'uikit'
import * as $ from 'jquery';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ApplicationService } from 'src/app/core/services/application.service';
import { EditAccountService } from 'src/app/core/services/edit-account.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import { Router } from '@angular/router';
import { K_GOOGLE_CAPTCHA } from 'src/app/shared/constants';
import { LoggerService } from 'src/app/core/authentication/logger.service';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';
// import 'bootstrap/dist/js/bootstrap';

@Component({
  selector: 'app-change-phone',
  templateUrl: './change-phone.component.html',
  styleUrls: ['./change-phone.component.scss', '../modal-screens.scss']
})
export class ChangePhoneComponent implements OnInit {


  changePhoneForm: FormGroup;
  pin: any;
  enablePinBtn = true;
  step = 1;
  @Input() userTelco;
  @Input() phoneNumber;
  resendSmsCount;
  config = {
    allowNumbersOnly: true,
    length: 5,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '48px',
      height: '48px'
    },
    inputClass: 'otp-pin-input',
    containerClass: 'otp-container-class'
  }
  selectedPhoneCodeObj: any;
  phoneCodes: any;
  disableResendSMS = false;
  otpIntervalTime;
  otpRetryCount;
  resendTime;
  interval;
  hideButton = false;
  showResendSmsTimer: boolean = false;
  googleReCaptchaKey = K_GOOGLE_CAPTCHA;
  @Output() updateAccountData = new EventEmitter();
  updatedData: any;
  
  skinName = environment.skinName;
  constructor(public configService: ConfigurationService,  public baseService: BaseService, private storageService: StorageService, public settingsService: SettingsService,
     private appService: ApplicationService, private editAccountService: EditAccountService, private uikitService: UikitService, private formBuilder: FormBuilder,
      private router: Router, private editService: EditAccountService, private loggerService: LoggerService, private analyticsService: InhouseAnalyticsService) {
    this.googleReCaptchaKey = this.settingsService.googleRecaptcaKey;
    uikit.util.on(document, 'beforehide', '#change-phone', ()=>{
      this.destroyModal();
      this.changePhoneForm =  this.formBuilder.group({
        mobile: [this.phoneNumber,
          [Validators.required,
          Validators.pattern(/^[0-9+]*$/),
          Validators.maxLength(this.selectedPhoneCodeObj.max_mobile_digits),
          Validators.minLength(this.selectedPhoneCodeObj.min_mobile_digits)]]
      });
    });
  }

  ngOnInit(): void {
    this.otpIntervalTime = (this.settingsService.settings.otp_interval_time * 1000) || 90000;
    this.resendTime = +(this.settingsService.settings?.otp_interval_time);
    this.otpRetryCount = +(this.settingsService.settings?.otp_retry_count) || 3;
    this.resendSmsCount = 0;
    this.hideButton = false;
    this.phoneCodes = this.appService.phoneCodes;
    this.editAccountService.mobileVerification.subscribe(data =>{
      this.hideButton = data;
    });
    const selectedPhoneCode = this.storageService.getLocalStore('phone_code');
    this.selectedPhoneCodeObj = this.phoneCodes.find((obj) => obj?.phone_code == selectedPhoneCode);
    const maxLimit = this.settingsService.loginWithMobileEnabled ? this.selectedPhoneCodeObj?.max_mobile_digits :  13;
    const minLimit = this.settingsService.loginWithMobileEnabled ? this.selectedPhoneCodeObj?.min_mobile_digits :  4;
    this.changePhoneForm = this.formBuilder.group({
      mobile: [this.phoneNumber,
        [Validators.required,
        Validators.maxLength(maxLimit),
        Validators.minLength(minLimit),
        Validators.pattern(/^[0-9+]*$/)]]
    });
    if (this.changePhoneForm.value.mobile == this.phoneNumber) this.hideButton = true;
  }

  changePhone(){
    this.changePhoneForm.markAllAsTouched();
  }

  onKeyUp(e){
  if (e.target.value !== this.phoneNumber) this.hideButton = false
    else this.hideButton = true;
  }

  onKeyDown(event) {
    if ((this.containsSpecialCharsExceptPlus(event.target.value)) && this.containsAlphabets(event.target.value)) {
      this.hideButton = true;
    }
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab'];
    const regex = new RegExp('^[0-9+]*$', 'g');
    if (!allowedKeys.includes(event.key) && !allowedKeys.includes(event.code) && !regex.test(event.key)) {
      event.preventDefault();
    }
  }

  containsAlphabets(input: string): boolean {
    return /[a-zA-Z]/.test(input); // return true if the pattern is found in the string
  }
  containsSpecialCharsExceptPlus(str: string): boolean {
    const pattern = /[^a-zA-Z0-9+]/;
    return pattern.test(str); // return true if the pattern is found in the string
  }

  destroyModal(){
    this.step = 1;
    this.resendSmsCount = 0;
    this.showResendSmsTimer = false;
    this.hideButton = true;
    this.changePhoneForm.reset();
  }

  onPinChange(pin:any) {
    this.pin = pin;
    if(this.pin.length == 5) this.enablePinBtn = false;
    else this.enablePinBtn = true;
  }

  setPhoneCode(obj) {
    this.selectedPhoneCodeObj = obj;
  }

  containsNumbers(str) {
    return /\d/.test(str);
  }

  sendVerficationRequest(resendFlag) {
    this.hideButton = true;
    if(!this.disableResendSMS) {
      if (resendFlag) this.disableResendSMS = true;
      this.editAccountService.mobileVerification.next(true);
      let mobileInvalid = this.configService.localeKeys?.["account.invalid_mob_numb.text"];
      if (this.changePhoneForm.value.mobile == 0 && this.changePhoneForm.value.mobile !== null && this.changePhoneForm.value.mobile !== 'null' && this.changePhoneForm.value.mobile !== '' && !this.containsNumbers(this.changePhoneForm.value.mobile)) {
          this.uikitService.staticErrorMessage(mobileInvalid);
          this.editAccountService.mobileVerification.next(false);
          this.hideButton = false;
          return;
      }
      if ((this.resendSmsCount < this.otpRetryCount) || this.resendSmsCount === 0) {
        // resend sms api should not be called more than otp_retry_count value
        const requestObj = Object.assign({}, this.changePhoneForm.value)
        requestObj.phone_code = this.selectedPhoneCodeObj?.phone_code;
        if (resendFlag) requestObj.resend = true;
        if(this.settingsService.googleRecaptchaEnabled == '1'){
          if(grecaptcha){
             grecaptcha.enterprise.ready(() => {
               grecaptcha.enterprise.execute(this.googleReCaptchaKey, {action: 'LOGIN'}).then((token) => {
                   // Add your logic to submit to your backend server here.
                  Object.assign(requestObj, {"recaptchaToken" : token});
                  if (this.selectedPhoneCodeObj?.login_with_mobile_enabled && this.settingsService?.loginWithMobileEnabled) this.submitMobileDetails(requestObj, resendFlag);
                  else this.submitOnlyMobileNumber(requestObj);
               });
             });
           }
        } else {
          if (this.selectedPhoneCodeObj?.login_with_mobile_enabled && this.settingsService?.loginWithMobileEnabled) this.submitMobileDetails(requestObj, resendFlag);
          else this.submitOnlyMobileNumber(requestObj);
        }
      } else {
        this.editAccountService.mobileVerification.next(false);
        this.destroyModal();
      }
    }
  }

  startResendCountDown() {
    this.showResendSmsTimer = true;
    this.interval = setInterval(() => {
      if(this.resendTime > 0) {
        this.resendTime--;
      } else {
        this.showResendSmsTimer = false;
        clearInterval(this.interval);
        this.resendTime = this.settingsService.settings.otp_interval_time;
      }
    },1000)
  }

  // when user country code has login_with_mobile_enabled as 1 and global flag loginWithMobileEnabled is enabled then we show country code for the user to select along with phone number edit and OTP verfication is done in this case
  submitMobileDetails(requestObj, resendFlag) {
    this.editAccountService.sendPhoneVerficationRequest(requestObj).subscribe(data => {
      if (data) {
        const eventObj = {
          event_type: 'event',
          event_name: 'Mobile Number Verification - Send Verification Code',
          event_status: 'Success',
        };
        this.analyticsService.trackUserActions(eventObj);

        if (resendFlag) {
          this.disableResendSMS = true;
          this.resendSmsCount += 1;
          this.startResendCountDown();
          setTimeout(() => {
             this.disableResendSMS = false;
          }, this.otpIntervalTime);
        }
        this.step = 2;
        this.updateAccountData.emit();
        this.hideButton = false;
        this.uikitService.staticSuccessMessage(data.message);
        this.editAccountService.mobileVerification.next(false);
      }
    }, error => {
      const eventObj = {
        event_type: 'event',
        event_name: 'Mobile Number Verification - Send Verification Code',
        event_status: 'Failure',
      };
      this.analyticsService.trackUserActions(eventObj);
    });
  }

  // when user coutry code does not have login_with_mobile_enabled as 1 only phone number must be edited and sent
  submitOnlyMobileNumber(requestObj) {
    this.editService.editAccountFun(requestObj).subscribe({
      next: res => {
        this.updatedData = res;
        const eventObj = {
          event_type: 'event',
          event_name: 'Change Mobile Number',
          event_status: 'Success',
        };
        this.analyticsService.trackUserActions(eventObj);
      }, error: (err) => {
        const eventObj = {
          event_type: 'event',
          event_name: 'Change Mobile Number',
          event_status: 'Failure',
          event_description: err.error?.error?.message
        };
        this.analyticsService.trackUserActions(eventObj);
      }, complete: () => {
        if (this.updatedData.status_code === 200) {
          //this.uikitService.staticSuccessMessage(this.updatedData.message);
          const updateMemoryData: any = {};
          updateMemoryData.login_by = this.updatedData.data.user_login_by;
          updateMemoryData.user_picture = this.updatedData.data.user_picture;
          updateMemoryData.user_name = this.updatedData.data.user_name;
          updateMemoryData.user_type = this.updatedData.data.user_type;
          updateMemoryData.user_telco = this.updatedData.data.user_telco;
          updateMemoryData.one_time_subscription = this.updatedData.data.one_time_subscription;
          this.loggerService.updatedMemoryStorage(updateMemoryData);
          this.step = 3;
          this.updateAccountData.emit();
          this.hideButton = false;
          this.storageService.setLocalStore('sessionStorage', updateMemoryData);
          this.storageService.setLocalStore('event_user_status', this.updatedData.data.user_type);
        } else {
          this.uikitService.staticErrorMessage(this.updatedData.error.message);
        }
        if (this.updatedData.error && this.updatedData.error.code !== 1002) {
          this.uikitService.staticErrorMessage(this.updatedData.error.message);
        }
      }
    });
  }

  sendVerficationCode() {
    this.enablePinBtn = true;
    const request = {
      otp: this.pin,
      mobile: this.changePhoneForm.value.mobile,
      phone_code : this.selectedPhoneCodeObj?.phone_code,
    }
    this.editAccountService.mobileVerification.next(true);
    this.editAccountService.editAccountFun(request).subscribe(data => {
      this.step = 3;
      this.updateAccountData.emit();
      this.changePhoneForm.get('mobile').setValue(data.user_mobile);
      this.enablePinBtn = false
      this.editAccountService.mobileVerification.next(false)
    });
  }

}
